module.exports = __webpack_public_path__ + "fileicon.png?a04644a426225dca189038d0767800ad";